var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowBackInline = function SvgIconArrowBackInline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 8,
    viewBox: "0 0 10 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-arrow-back-grey",
    d: "M312.867 118.266a.5.5 0 0 0 .854-.372v-2.418h4.5a1.056 1.056 0 0 0 0-2.109h-4.5v-2.417a.5.5 0 0 0-.854-.373l-3.646 3.845Z",
    transform: "translate(-309.221 -110.422)",
    fill: "currentColor"
  })));
};
export { SvgIconArrowBackInline as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTAgOCI+CiAgICA8cGF0aCBpZD0iaWNvbi1hcnJvdy1iYWNrLWdyZXkiCiAgICAgICAgICBkPSJNMzEyLjg2NywxMTguMjY2YS41LjUsMCwwLDAsLjg1NC0uMzcydi0yLjQxOGg0LjVhMS4wNTYsMS4wNTYsMCwwLDAsMC0yLjEwOWgtNC41VjExMC45NWEuNS41LDAsMCwwLS44NTQtLjM3M2wtMy42NDYsMy44NDVaIgogICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMwOS4yMjEgLTExMC40MjIpIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";